<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2 p-0 m-0">
            <bita-bootbutton
              type="primary"
              title="افزودن ترمینال"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createTerminal"
            />
          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="editForm"
      modal-id="edit-modal"
      title="ویرایش ترمینال"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="editForm"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن ترمینال"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import TerminalForm from "./Form";

export default {
  components: { "form-modal": TerminalForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت ترمینال",
          link: "/management/terminals",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      terminal: {
        name: "",
      },
      editForm: {},
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام ترمینال", width: "100px" },
        {
          field: "status",
          title: "وضعیت",
          template: (e) =>
            e.status == 1 ? "فعال" : e.status == 2 ? "عدم دسترسی" : "غیرفعال",
             width: "100px"
        },
        {
          title: "عملیات",
          command: [],
           width: "150px"
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      if (this.$acl.isSuperAdmin)
        commands.push({
          text: "hard-delete",
          click: this.hardDelete,
          template: this.gridButtons.hardDelete,
        });
      return commands;
    },
    hardDelete(e) {
      let terminal = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف ترمینال ${terminal.name} به صورت کامل اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `terminals/${terminal.id}/hard-delete`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "management/terminals?include=cities")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    save() {
      this.$refs.test.validate().then((result) => {
        if (result) {
          this.isLoadingForm = true;
          this.$persistClient("post", "terminals", this.terminal)
            .then((res) => {
              this.$izitoast(
                "success",
                "عملیات موفق",
                "ترمینال مورد نظر ایجاد شد"
              );
              this.terminal = {
                name: "",
              };
              this.$refs.test.reset();
            })
            .finally(() => {
              this.isLoadingForm = false;
            });
        }
      });
    },
    edit(e) {
      this.editForm = this.$refs.grid.getSelectedGridRow(e);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let terminal = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف ${terminal.name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `terminals/${terminal.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createTerminal() {
      this.editForm = {
        name: "",
        state_id: 0,
        status: 1,
        city_ids: 0,
      };
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
        status: e.status,
        state_id: e.state_id,
        city_ids: e.city_ids,
      };
      this.$persistClient("patch", `terminals/${e.id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
        city_ids: e.city_ids,
        status: e.status,
        state_id: e.state_id,
      };
      this.$persistClient("post", "terminals", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalCreate();
        });
    },
  },
};
</script>
